<div class="grid grid-auto-1 content md3-surface">
  <div class="layout-auto-1-auto width-400 md3-card-on-surface">
    <exg-search-bar (Search)="config.userTable.search($event)" [placeholder]="getRessource('SearchHolder')">
      <ng-template #rightTemplate>
        <i (click)="config.userTable.loadData()" class="search-action fal fa-sync"></i>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-filter"
               [class.fas]="appSvc.metaInfo.uiFilterAktiv(userTable.uiFilter, 1).length > 0"
               [class.fal]="appSvc.metaInfo.uiFilterAktiv(userTable.uiFilter, 1).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCUserTableFilterControl
                            (onActivateFilter)="config.userTable.pageChanged(1);popup.close()"
                            [MetaInfo]="userTable.MetaInfo"
                            [showFilter]="true" [uiFilter]="userTable.uiFilter"
                            [visibility]="popup.visibility !== 'hidden'"
                            [uiSort]="userTable.uiSort">
            </app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
      </ng-template>
    </exg-search-bar>
    <div class="content">
      <exg-data-list #VCUserTable
                     [displayState]="config.userTable.state"
                     [rowSource]="userTable.data"
                     [selectKey]="config.userTable.selectKey"
                     [allowSingleSelection]="true"
                     (RowChange)="config.userTable.selectionChanged($event)">
        <ng-template #rowTemplate let-row>
          <div class="list-row-auto-1">
            <div></div>
            <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
              <div class="list-metadata" style="margin-left:0">
                <div>
                  {{getUsrTyp(row.usrType)}}
                </div>
                <div></div>
              </div>
              <div class="list-metadata ">
                <div
                  class="typo-right">
                  {{enumSvc.getEnumerationText("CrmRollePerson", row.oe_CrmRolle)}}
                </div>
                <div class="typo-right">

                </div>
              </div>
              <div class="span-2">
                <div class="grid-1-auto">
                  <div><strong>{{row.oeName}}, {{row.oeEName}}</strong></div>
                  <div>
                    <div class="list-metadata ">Aktive Vorgänge: {{row.activeTaskCount}} / {{(row.CapActive == 0) ?
                                                                                             '&#8734;' :
                                                                                             row.CapActive}}</div>
                  </div>
                </div>
              </div>
              <div class="span-2 list-secondary-text">
                <div class="grid-1-auto">
                  <div>
                    <div>{{row.adrZusatz}}</div>
                    <div>{{row.adrStr}} {{row.adrHNum}}</div>
                    <div>{{row.adrPlz}} {{row.adrOrt}}</div>
                  </div>
                  <div class="list-metadata">
                    <div class="typo-container-s-s-q" style="margin: 0;line-height: unset">
                      <span>KW {{KW}} (Akt):</span>
                      <span> {{row.activeTaskCountWeek}} / {{(row.CapWeek == 0) ? '&#8734;' :
                                                             row.CapWeek}}</span>
                      <q></q>
                      <span>KW {{KW + 1}}:</span>
                      <span> {{row.activeTaskCountWeek1}} / {{(row.CapWeek == 0) ?
                                                              '&#8734;' :
                                                              row.CapWeek}}</span>
                      <q></q>
                      <span>KW {{KW + 2}}:</span>
                      <span> {{row.activeTaskCountWeek2}} / {{(row.CapWeek == 0) ?
                                                              '&#8734;' :
                                                              row.CapWeek}}</span>
                      <q></q>
                      <span>KW {{KW + 3}}:</span>
                      <span> {{row.activeTaskCountWeek3}} / {{(row.CapWeek == 0) ?
                                                              '&#8734;' :
                                                              row.CapWeek}}</span>
                      <q></q>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </ng-template>
      </exg-data-list>
    </div>
    <exg-pager (PageChange)="config.userTable.pageChanged($event)" *ngIf="true"
               [pagingSource]="userTable.paging">
    </exg-pager>
  </div>
  <div class="content md3-card-on-surface">
    <app-sv-user-profile [data]="config.userTable.selectedRow"></app-sv-user-profile>
  </div>
</div>
